import axiosConfig from "../axiosConfig";
import axios from "axios";

export const apiGetPosts = () => new Promise(async (resolve, reject) => {
    try {
        const response = await axiosConfig({
            method: 'get',
            url: `post/`
        })
        resolve(response)
    } catch (error) {
        reject(error)
    }
});
export const apiGetPostsLimit = (query) => new Promise(async (resolve, reject) => {
    try {
        const response = await axiosConfig({
            method: 'get',
            url: `post/limit`,
            params: query
        })
        resolve(response)
    } catch (error) {
        reject(error)
    }
});
export const apiGetNewPosts = () => new Promise(async (resolve, reject) => {
    try {
        const response = await axiosConfig({
            method: 'get',
            url: `post/newPost`,
        })
        resolve(response)
    } catch (error) {
        reject(error)
    }
});
export const apiCreateNewPost = (payload) => new Promise(async (resolve, reject) => {
    try {
        const response = await axiosConfig({
            method: 'post',
            url: `post/createPost`,
            data: payload
        })
        resolve(response)
    } catch (error) {
        reject(error)
    }
});
export const apiUploadImages = (images) => new Promise(async (resolve, reject) => {
    try {
        const response = await axios({
            method: 'post',
            url: `https://api.cloudinary.com/v1_1/${process.env.REACT_APP_CLOUD_NAME}/image/upload`,
            data: images
        })
        resolve(response)
    } catch (error) {
        reject(error)
    }
});

export const apiGetPostsLimitAdmin = (query) => new Promise(async (resolve, reject) => {
    try {
        const response = await axiosConfig({
            method: 'get',
            url: `post/limit-admin`,
            params: query
        })
        resolve(response)
    } catch (error) {
        reject(error)
    }
});

export const apiUpdatePost = (payload) => new Promise(async (resolve, reject) => {
    try {
        const response = await axiosConfig({
            method: 'put',
            url: `post/update-post`,
            data: payload
        })
        resolve(response)
    } catch (error) {
        reject(error)
    }
});

export const apiDeletePost = (postId) => new Promise(async (resolve, reject) => {
    try {
        const response = await axiosConfig({
            method: 'delete',
            url: `post/delete-post`,
            params: { postId }
        })
        resolve(response)
    } catch (error) {
        reject(error)
    }
});